// extracted by mini-css-extract-plugin
export var equalColumn = "_cs-0";